<script>
import resources from './resources'

export default {
  name: 'professional-employee-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Funcionário por Estabelecimento", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        ul.nav.nav-tabs
          li.active
            a(href='#') Listagem
          li
            router-link(:to="{name: 'professional.company.employees.create'}")
              a(href="#") Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")

        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-8.col-sm-4
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.name", type='text', placeholder='Buscar Funcionário')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 

            card-add(label='Novo<br>Funcionário', route='professional.company.employees.create', icon='')

            .list-item.white-bg.list-item.list-one-line(v-for=('employee in employees'))
              .row.border-bottom
                h4.col-xs-7.col-sm-8 {{ employee.name }}
                .col-xs-5.col-sm-4
                  .exclude-list(@click.prevent="doDelete(employee)")
                    span.icon 
              .list-info
                | Nascimento:
                strong  {{ employee.birthdate }}

          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/employees/index/index.vue